// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"cfb8c3eb","453":"af7ab50c"}[chunkId] + ".chunk.js";
};